/**
 * Email / sign-in modal art (`EmailAuthPanel`, `EmailSignInModal`).
 *
 * The panel background reuses the Resource Swap modal parchment; the frame
 * controls (title plate, tabs, buttons, close) come from the dedicated
 * `public/assets/login-modal` set.
 */

const LOGIN_ASSETS = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/login-modal'

/** Full-bleed ornate portrait frame behind the modal content (aspect 979 / 1402). */
export const AUTH_MODAL_BG = `${LOGIN_ASSETS}/bg_login.webp`
/** Ornate title plate straddling the top of the panel (aspect 620 / 165). */
export const AUTH_TITLE_PLATE = `${LOGIN_ASSETS}/modal_logo.webp`
/** Inner sub-panel frame holding the form area below the tabs (aspect 970 / 1238). */
export const AUTH_SUBPANEL_BG = `${LOGIN_ASSETS}/bg_sublogin.webp`
/** Recessed input frame (dark field, cream text). */
export const AUTH_INPUT_BG = `${LOGIN_ASSETS}/input_box.webp`
/** Email field label icon (aspect ~1:1). */
export const AUTH_ICON_EMAIL = `${LOGIN_ASSETS}/icon_email.webp`
/** Password field label icon (aspect ~1:1). */
export const AUTH_ICON_LOCK = `${LOGIN_ASSETS}/icon_lock.webp`
/** Login / Sign-up tab plate — inactive (aspect 379 / 85). */
export const AUTH_TAB_BG = `${LOGIN_ASSETS}/btn_login.webp`
/** Login / Sign-up tab plate — active (aspect 434 / 92). */
export const AUTH_TAB_ACTIVE_BG = `${LOGIN_ASSETS}/btn_active.webp`
/** Primary action button art (aspect 685 / 124). */
export const AUTH_BTN_PRIMARY = `${LOGIN_ASSETS}/btn_processing.webp`
/** Google sign-in button art with the Google mark baked in (aspect 725 / 131). */
export const AUTH_BTN_GOOGLE = `${LOGIN_ASSETS}/btn_google.webp`
/** Top-right close control (aspect ~1:1). */
export const AUTH_BTN_CLOSE = `${LOGIN_ASSETS}/btn_close.webp`

/**
 * Every asset above, for the preload manifest — derived from the same constants the component
 * renders, so the list cannot drift out of sync.
 *
 * This was an empty array with a comment saying "the reskinned modal uses local assets, so there
 * is nothing to preload from Vercel Blob". That stopped being true when the art moved to
 * `login-modal/` on the CDN: every URL above is remote. The result was that the sign-in modal —
 * the first interactive screen in the game, and one nobody can skip — was the ONLY screen with no
 * preloading at all. It is 0.13 MB in total; there was never a reason not to gate it.
 */
export const EMAIL_AUTH_MODAL_PRELOAD_URLS: readonly string[] = [
  AUTH_MODAL_BG,
  AUTH_TITLE_PLATE,
  AUTH_SUBPANEL_BG,
  AUTH_INPUT_BG,
  AUTH_ICON_EMAIL,
  AUTH_ICON_LOCK,
  AUTH_TAB_BG,
  AUTH_TAB_ACTIVE_BG,
  AUTH_BTN_PRIMARY,
  AUTH_BTN_GOOGLE,
  AUTH_BTN_CLOSE,
]
